module.exports = __webpack_public_path__ + "e0e6bf67bfd2de109800ab8dbdd3679f.svg";